// EXTERNAL DEPENDENCIES
import React from 'react'

// HELPERS
import { useModularSellerViewPageContent } from '@/screens/business-profile-page/hooks'

// COMPONENTS
import {
  BodyText,
  CaptionText,
  Col,
  Icon,
  Link,
  Row,
} from '@paypalcorp/pp-react'

// TEST IDS
import { CLICKABLE_ROW_TEST_ID } from '../../../../constants/test-ids'

// STYLES
import styles from './styles.module.less'
import { lightGrayColor } from '@/styles/colors'

// TYPES
type ClickableRowProp = {
  label: string
  description: string
  icon: string
  customRightLinkText?: string
  isLoading: boolean
  onClick: () => void
}

/**
 * Displays a row of content with icon, label and description
 */
export default function ClickableRow({
  customRightLinkText,
  description,
  icon,
  isLoading,
  label,
  onClick,
}: Readonly<ClickableRowProp>) {
  const getContent = useModularSellerViewPageContent()
  const editRowButtonText = getContent('editRowButton')

  return (
    <Row
      data-testid={CLICKABLE_ROW_TEST_ID}
      noGutters
      className={styles.clickableRow}
      onClick={onClick}
    >
      <Col className={styles.removePadding} xs='auto'>
        <Icon name={icon} color='sysColorSecondaryMain' />
      </Col>
      <Col className={styles.removePadding}>
        <BodyText>{label}</BodyText>
        <CaptionText
          isLoading={isLoading}
          className={styles.clickableRowDescriptionContainer}
          style={{ color: lightGrayColor }}
        >
          {description}
        </CaptionText>
      </Col>
      <Col className={styles.removePadding} xs='auto'>
        <Link isLoading={isLoading} className={styles.clickableRowLink}>
          {customRightLinkText || editRowButtonText}
        </Link>
      </Col>
    </Row>
  )
}
